import React from 'react';
import ReactModal from 'react-modal';

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 1000
  },
  content: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    marginRight: '0',
    marginLeft: '230px',
    // transform: 'translate(-50%, -50%)',
    border: '1px solid rgba(0, 0, 0, 0.4)',
    width: 'auto',
    boxShadow: '0 3px 7px rgba(0, 0, 0, 0.4)',
    // maxWidth: '100%',
    // maxHeight: '95%',
    borderRadius: 0,
    padding: 0,
    backgroundColor: 'rgb(244,244,244)'
  }
};
const small = {
  top: '50%',
  left: '50%',
  right: '0',
  bottom: '0',
  marginRight: '0',
  transform: 'translate(-50%, -50%)',
  border: '1px solid rgba(0, 0, 0, 0.4)',
  width: '900px',
  boxShadow: '0 3px 7px rgba(0, 0, 0, 0.4)',
  maxWidth: '95%',
  maxHeight: '95%',
  borderRadius: 0,
  padding: 0
};

export default ({ isOpen, allowClickOverlay = true, onCloseClick, extraStyles, children, type, rootEl = '#root', parentSelector = 'main-wrap' }) => {
  ReactModal.setAppElement(rootEl);
  const modalType = type ? { overlay: modalStyles.overlay, content: small } : modalStyles;
  const styleWithExtras = { ...modalType, content: { ...modalType.content, ...extraStyles } };
  return (
    <ReactModal
      style={styleWithExtras}
      isOpen={isOpen}
      contentLabel="Modal"
      onRequestClose={onCloseClick}
      parentSelector={() => document.getElementById(parentSelector)}
      shouldCloseOnOverlayClick={allowClickOverlay}
      shouldCloseOnEsc={allowClickOverlay}
    >
      {children}
    </ReactModal>
  );
};
